<template>
  <div class="animated fadeIn">
    <basic-heading title="New Instrument Definition" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'add instrument'">
      <template #gated-content>
        <instrument-form @submit="submit" />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import InstrumentForm from "@/components/lab/instrument/InstrumentForm";
import InstrumentJigModel from "@/models/lab/InstrumentJigModel";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import { instrumentNotifications } from "@/shared/notifications";
import { notificationOptions } from "@/shared/toast-notification-options";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const InstrumentRepository = LabRepositoryFactory.get("instrument");

Vue.use(VueNotifications, notificationOptions);

export default {
  name: "InstrumentAdd",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    InstrumentForm,
    PermissionAlertGate,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/instrument",
            title: "Instrument list",
          },
        ],
      };
    },
  },
  methods: {
    async submitJig(instrument_id, jig) {
      const instrument_jig = new InstrumentJigModel({ instrument_id, jig });
      try {
        await instrument_jig.save();
        this.addSuccess();
        this.$router.push(`${instrument_id}`);
      } catch ({ response }) {
        this.addFail();
      }
    },
    async submit(form_data, jig) {
      try {
        const { data } = await InstrumentRepository.create(form_data);
        this.submitJig(data.id, jig);
      } catch ({ response }) {
        this.addFail();
      }
    },
  },
  notifications: instrumentNotifications,
};
</script>
